import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=58acb8be&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=js&"
export * from "./ErrorView.vue?vue&type=script&lang=js&"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=58acb8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acb8be",
  null
  
)

export default component.exports